<template>
  <div>
    <slot></slot>
    <div style="display:flex" v-if="focus && focus.state == 'ontrack'">
      <div>
        <div v-if="listing">
          <input
            class="url-input"
            placeholder="put youtube url here..."
            v-model="inputYtbUrl"
          />
          <div class="add-btn">
            <svg
              @click="handleAddVideo()"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mt-3 ml-3 mr-4 btm-icons"
            >
              <circle cx="10" cy="10" r="10" fill="#FF0000" />
              <path
                d="M10.5 5C10.5 4.72386 10.2761 4.5 10 4.5C9.72386 4.5 9.5 4.72386 9.5 5H10.5ZM9.5 16C9.5 16.2761 9.72386 16.5 10 16.5C10.2761 16.5 10.5 16.2761 10.5 16H9.5ZM9.5 5V16H10.5V5H9.5Z"
                fill="white"
              />
              <path
                d="M5 9.5C4.72386 9.5 4.5 9.72386 4.5 10C4.5 10.2761 4.72386 10.5 5 10.5L5 9.5ZM15 10.5C15.2761 10.5 15.5 10.2761 15.5 10C15.5 9.72386 15.2761 9.5 15 9.5L15 10.5ZM5 10.5L15 10.5L15 9.5L5 9.5L5 10.5Z"
                fill="white"
              />
            </svg>
          </div>
        </div>
        <!--- Overlay starts here --->
        <div
          class="tool-overlay"
          :class="{ 'tool-overlay-active': fullscreen === true }"
        >
          <div v-if="fullscreen">
            <Overlay
              @hideOverlay="showScreen()"
              :video="currentVid"
              :img="currentImg"
            />
          </div>
        </div>

        <!----Home start--->

        <div v-if="home">
          <div
            v-if="tool.plan && tool.plan.videos && tool.plan.videos.length"
            class="scroll-horizontal"
          >
            <div
              style="display:flex;"
              v-for="(video, index) in tool.plan.videos.filter(
                el => !el._deleted_at
              )"
              :key="index"
              class="pt-1 align-items-center"
            >
              <div class="uploaded-images-wrapper">
                <span
                  @click="scrollLeft(index)"
                  class="images-nav left-nav"
                  v-if="scrollLeftBtn"
                >
                  <div></div>
                  <svg
                    width="6"
                    height="9"
                    viewBox="0 0 6 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M5 1L1 4.5L5 8"
                      stroke="white"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
                <span
                  class="images-nav center-nav"
                  v-b-modal="tool && tool.text"
                  @click="showScreen()"
                >
                  <svg
                    width="35"
                    height="25"
                    viewBox="0 0 35 25"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M34.2268 3.89931C34.0261 3.14563 33.6345 2.45853 33.091 1.90643C32.5476 1.35432 31.8712 0.956474 31.1293 0.7525C28.4133 0 17.4821 0 17.4821 0C17.4821 0 6.55031 0.0227777 3.83426 0.775278C3.09235 0.979264 2.416 1.37713 1.87254 1.92926C1.32908 2.4814 0.937491 3.16852 0.736757 3.92222C-0.0847857 8.82472 -0.403477 16.295 0.759316 21.0014C0.96007 21.7551 1.35167 22.4422 1.89513 22.9943C2.43858 23.5464 3.11493 23.9442 3.85682 24.1482C6.57287 24.9007 17.5044 24.9007 17.5044 24.9007C17.5044 24.9007 28.4357 24.9007 31.1516 24.1482C31.8935 23.9442 32.5699 23.5464 33.1134 22.9943C33.6569 22.4422 34.0485 21.7551 34.2493 21.0014C35.1158 16.0919 35.3828 8.62639 34.2268 3.89944V3.89931Z"
                      fill="#FF0000"
                    />
                    <path
                      d="M14.0027 17.7861L23.0712 12.4503L14.0029 7.11444L14.0027 17.7861Z"
                      fill="white"
                    />
                  </svg>
                </span>
                <span
                  class="images-nav right-nav"
                  @click="scrollRight(index)"
                  v-if="scrollRightBtn"
                >
                  <svg
                    width="6"
                    height="9"
                    viewBox="0 0 6 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 8L5 4.5L1 1"
                      stroke="white"
                      stroke-linecap="round"
                    />
                  </svg>
                </span>
                <div class="uploaded-images">
                  <div class="image">
                    <img
                      :title="video.video_url"
                      :src="video.img_url"
                      :height="60"
                      :width="71"
                      class="mr-4"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <b-row v-if="home">
              <b-col offset="8" class="mb-1">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="b-icon"
                >
                  <path
                    d="M12.4826 1H2.69922C1.76225 1 1 1.83848 1 2.86914V12.7246C1 13.7553 1.76225 14.5937 2.69922 14.5937H11.2983C11.8068 14.5937 12.2848 14.3759 12.6444 13.9804L13.6242 12.9026C13.9838 12.5071 14.1818 11.9812 14.1818 11.4219V2.86914C14.1818 1.83848 13.4196 1 12.4826 1ZM2.69922 1.90625H12.4826C12.9653 1.90625 13.358 2.33819 13.358 2.86914V4.17187H1.82386V2.86914C1.82386 2.33819 2.21654 1.90625 2.69922 1.90625ZM1.82386 12.7246V5.07812H13.358V10.9688H12.0707C11.4177 10.9688 10.8864 11.5532 10.8864 12.2715V13.6875H2.69922C2.21654 13.6875 1.82386 13.2556 1.82386 12.7246ZM13.0417 12.2618L12.0618 13.3396C11.9594 13.4522 11.8402 13.5394 11.7102 13.5984V12.2715C11.7102 12.0529 11.8719 11.875 12.0707 11.875H13.2769C13.2233 12.0179 13.1441 12.1492 13.0417 12.2618Z"
                    fill="#0A1A3A"
                  />
                  <path
                    d="M11.9806 6.90597C11.9806 6.65508 11.7587 6.45166 11.485 6.45166H3.5553C3.28157 6.45166 3.05969 6.65508 3.05969 6.90597C3.05969 7.15686 3.28157 7.36027 3.5553 7.36027H11.485C11.7587 7.36027 11.9806 7.15686 11.9806 6.90597Z"
                    fill="#0A1A3A"
                  />
                  <path
                    d="M10.4938 8.72318H4.54651C4.27278 8.72318 4.0509 8.92659 4.0509 9.17748C4.0509 9.42837 4.27278 9.63179 4.54651 9.63179H10.4938C10.7675 9.63179 10.9894 9.42837 10.9894 9.17748C10.9894 8.92659 10.7675 8.72318 10.4938 8.72318Z"
                    fill="#0A1A3A"
                  />
                </svg>
                <svg
                  @click="showScreen()"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  class="b-icon"
                >
                  <g clip-path="url(#clip0)">
                    <path
                      d="M18.2169 14.0649C18.2169 13.6537 17.9019 13.3212 17.5106 13.3212C17.1226 13.3221 16.8038 13.6537 16.8038 14.0649V15.6045L13.9531 12.7523C13.6774 12.4761 13.2311 12.4761 12.9554 12.7523C12.6797 13.028 12.6797 13.4756 12.9554 13.7513L15.7925 16.5874H14.26C13.8427 16.5884 13.5064 16.9043 13.5064 17.2937C13.5064 17.684 13.8427 17.9995 14.26 17.9995H17.4628C17.8801 17.9995 18.216 17.6845 18.2174 17.2937C18.216 17.2833 18.2145 17.2752 18.2131 17.2648C18.2145 17.2516 18.2174 17.2373 18.2174 17.2236V14.0649H18.2169Z"
                      fill="#0A1A3A"
                    />
                    <path
                      d="M9.04597 12.7523L6.19661 15.6045V14.0649C6.19661 13.6537 5.87828 13.3221 5.48937 13.3212C5.09903 13.3212 4.78354 13.6537 4.78354 14.0649L4.78259 17.2241C4.78259 17.2378 4.78638 17.252 4.78733 17.2653C4.78638 17.2752 4.78449 17.2833 4.78354 17.2942C4.78449 17.685 5.12082 18 5.53768 18H8.7409C9.15729 18 9.4941 17.6845 9.4941 17.2942C9.4941 16.9048 9.15729 16.5888 8.7409 16.5879H7.20846L10.0455 13.7518C10.3203 13.4761 10.3203 13.0284 10.0455 12.7527C9.76933 12.4761 9.32262 12.4761 9.04597 12.7523Z"
                      fill="#0A1A3A"
                    />
                    <path
                      d="M13.9531 10.2468L16.8038 7.39649V8.93605C16.8038 9.34581 17.1227 9.6774 17.5106 9.67882C17.9019 9.67882 18.2169 9.34581 18.2169 8.93605V5.77594C18.2169 5.7622 18.2141 5.74799 18.2127 5.73567C18.2141 5.72572 18.2155 5.71625 18.2169 5.7063C18.2155 5.31502 17.8796 5 17.4628 5H14.26C13.8427 5 13.5064 5.31502 13.5064 5.7063C13.5064 6.09522 13.8427 6.41213 14.26 6.41307H15.7925L12.9554 9.24917C12.6797 9.52439 12.6797 9.9711 12.9554 10.2463C13.2311 10.5239 13.6774 10.5239 13.9531 10.2468Z"
                      fill="#0A1A3A"
                    />
                    <path
                      d="M7.20846 6.41307H8.74043C9.15682 6.41213 9.49363 6.09522 9.49363 5.7063C9.49363 5.31502 9.15682 5 8.74043 5H5.53768C5.12082 5 4.78449 5.31502 4.78354 5.7063C4.78449 5.71625 4.78638 5.72572 4.78733 5.73567C4.78638 5.74799 4.78259 5.76172 4.78259 5.77594L4.78354 8.93652C4.78354 9.34628 5.09903 9.6793 5.48937 9.6793C5.87828 9.67788 6.19661 9.34628 6.19661 8.93652V7.39697L9.04597 10.2468C9.32262 10.5239 9.76933 10.5239 10.0455 10.2468C10.3203 9.97158 10.3203 9.52487 10.0455 9.24964L7.20846 6.41307Z"
                      fill="#0A1A3A"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </b-col>
            </b-row>
          </div>
        </div>

        <!----Home End--->

        <!---- Listing start ---->
        <div
          v-if="smallscreen"
          class="tool-overlay-small"
          :class="{ 'tool-overlay-active-small': smallscreen === true }"
        >
          <div class="cross mt-2">
            <svg
              @click="showSmallScreen()"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 1L15 15"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
              <path
                d="M1 15L15 1"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
          </div>
          <Player
            @videoPaused="videoPaused"
            @proceedVideo="proceedVideo"
            :id="videoId"
            type="youtube"
          />
          <!-- <iframe width="470px" height="250px" :src="currentVid"> </iframe> -->
          <textarea
            rows="6"
            placeholder="Your notes here.."
            v-model="noteVideo"
            class="notepad"
          />
        </div>
        <div v-if="listing">
          <div
            v-if="tool.plan && tool.plan.videos && tool.plan.videos.length"
            class="scroll-verticle"
          >
            <div
              style="display:flex;background: #F8F8F8;"
              v-for="(video, index) in tool.plan.videos.filter(
                el => !el._deleted_at
              )"
              :key="index"
              class="my-1 pt-1 align-items-center"
            >
              <img
                :title="video.video_url"
                :src="video.img_url"
                :height="51"
                :width="71"
                class="mr-4"
              />
              <span
                style="margin-left: -61px; width:10px; height:10"
                v-b-modal="tool && tool.text"
                @click="
                  showSmallScreen(video.video_url, video.img_url, video.videoId)
                "
              >
                <svg
                  width="13"
                  height="13"
                  viewBox="0 0 13 13"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0 12.9998L13 6.49983L0.000195885 -0.000167847L0 12.9998Z"
                    fill="white"
                  />
                </svg>
              </span>
            </div>
            <div>
              <b-row v-if="listing" class="mt-7">
                <b-col offset="8" class="mb-1">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="b-icon"
                  >
                    <path
                      d="M12.4826 1H2.69922C1.76225 1 1 1.83848 1 2.86914V12.7246C1 13.7553 1.76225 14.5937 2.69922 14.5937H11.2983C11.8068 14.5937 12.2848 14.3759 12.6444 13.9804L13.6242 12.9026C13.9838 12.5071 14.1818 11.9812 14.1818 11.4219V2.86914C14.1818 1.83848 13.4196 1 12.4826 1ZM2.69922 1.90625H12.4826C12.9653 1.90625 13.358 2.33819 13.358 2.86914V4.17187H1.82386V2.86914C1.82386 2.33819 2.21654 1.90625 2.69922 1.90625ZM1.82386 12.7246V5.07812H13.358V10.9688H12.0707C11.4177 10.9688 10.8864 11.5532 10.8864 12.2715V13.6875H2.69922C2.21654 13.6875 1.82386 13.2556 1.82386 12.7246ZM13.0417 12.2618L12.0618 13.3396C11.9594 13.4522 11.8402 13.5394 11.7102 13.5984V12.2715C11.7102 12.0529 11.8719 11.875 12.0707 11.875H13.2769C13.2233 12.0179 13.1441 12.1492 13.0417 12.2618Z"
                      fill="#0A1A3A"
                    />
                    <path
                      d="M11.9806 6.90597C11.9806 6.65508 11.7587 6.45166 11.485 6.45166H3.5553C3.28157 6.45166 3.05969 6.65508 3.05969 6.90597C3.05969 7.15686 3.28157 7.36027 3.5553 7.36027H11.485C11.7587 7.36027 11.9806 7.15686 11.9806 6.90597Z"
                      fill="#0A1A3A"
                    />
                    <path
                      d="M10.4938 8.72318H4.54651C4.27278 8.72318 4.0509 8.92659 4.0509 9.17748C4.0509 9.42837 4.27278 9.63179 4.54651 9.63179H10.4938C10.7675 9.63179 10.9894 9.42837 10.9894 9.17748C10.9894 8.92659 10.7675 8.72318 10.4938 8.72318Z"
                      fill="#0A1A3A"
                    />
                  </svg>
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    class="b-icon"
                  >
                    <g clip-path="url(#clip0)">
                      <path
                        d="M18.2169 14.0649C18.2169 13.6537 17.9019 13.3212 17.5106 13.3212C17.1226 13.3221 16.8038 13.6537 16.8038 14.0649V15.6045L13.9531 12.7523C13.6774 12.4761 13.2311 12.4761 12.9554 12.7523C12.6797 13.028 12.6797 13.4756 12.9554 13.7513L15.7925 16.5874H14.26C13.8427 16.5884 13.5064 16.9043 13.5064 17.2937C13.5064 17.684 13.8427 17.9995 14.26 17.9995H17.4628C17.8801 17.9995 18.216 17.6845 18.2174 17.2937C18.216 17.2833 18.2145 17.2752 18.2131 17.2648C18.2145 17.2516 18.2174 17.2373 18.2174 17.2236V14.0649H18.2169Z"
                        fill="#0A1A3A"
                      />
                      <path
                        d="M9.04597 12.7523L6.19661 15.6045V14.0649C6.19661 13.6537 5.87828 13.3221 5.48937 13.3212C5.09903 13.3212 4.78354 13.6537 4.78354 14.0649L4.78259 17.2241C4.78259 17.2378 4.78638 17.252 4.78733 17.2653C4.78638 17.2752 4.78449 17.2833 4.78354 17.2942C4.78449 17.685 5.12082 18 5.53768 18H8.7409C9.15729 18 9.4941 17.6845 9.4941 17.2942C9.4941 16.9048 9.15729 16.5888 8.7409 16.5879H7.20846L10.0455 13.7518C10.3203 13.4761 10.3203 13.0284 10.0455 12.7527C9.76933 12.4761 9.32262 12.4761 9.04597 12.7523Z"
                        fill="#0A1A3A"
                      />
                      <path
                        d="M13.9531 10.2468L16.8038 7.39649V8.93605C16.8038 9.34581 17.1227 9.6774 17.5106 9.67882C17.9019 9.67882 18.2169 9.34581 18.2169 8.93605V5.77594C18.2169 5.7622 18.2141 5.74799 18.2127 5.73567C18.2141 5.72572 18.2155 5.71625 18.2169 5.7063C18.2155 5.31502 17.8796 5 17.4628 5H14.26C13.8427 5 13.5064 5.31502 13.5064 5.7063C13.5064 6.09522 13.8427 6.41213 14.26 6.41307H15.7925L12.9554 9.24917C12.6797 9.52439 12.6797 9.9711 12.9554 10.2463C13.2311 10.5239 13.6774 10.5239 13.9531 10.2468Z"
                        fill="#0A1A3A"
                      />
                      <path
                        d="M7.20846 6.41307H8.74043C9.15682 6.41213 9.49363 6.09522 9.49363 5.7063C9.49363 5.31502 9.15682 5 8.74043 5H5.53768C5.12082 5 4.78449 5.31502 4.78354 5.7063C4.78449 5.71625 4.78638 5.72572 4.78733 5.73567C4.78638 5.74799 4.78259 5.76172 4.78259 5.77594L4.78354 8.93652C4.78354 9.34628 5.09903 9.6793 5.48937 9.6793C5.87828 9.67788 6.19661 9.34628 6.19661 8.93652V7.39697L9.04597 10.2468C9.32262 10.5239 9.76933 10.5239 10.0455 10.2468C10.3203 9.97158 10.3203 9.52487 10.0455 9.24964L7.20846 6.41307Z"
                        fill="#0A1A3A"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>

        <!---- chart start ---->

        <div v-if="chart">
          <div class=".chart mt-4">
            <VueApexCharts
              type="donut"
              :options="options"
              :series="series"
            ></VueApexCharts>
          </div>
          <!----- chart Content Here --->
        </div>

        <!---- Chart End-->

        <!--- bottom icons start --->
        <div class="mt-3 ml-5 mr-4 btm-icons">
          <svg
            v-if="!home"
            width="26"
            height="24"
            viewBox="0 0 19 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="b-icon"
            @click="selectHome()"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M7.94768 7.08522C7.77268 6.99184 7.53275 6.97363 7.33065 7.03839C7.12853 7.10314 7 7.2394 7 7.38889V13.6111C7 13.7606 7.12853 13.8969 7.33065 13.9616C7.53275 14.0264 7.77268 14.0082 7.94768 13.9147L13.781 10.8036C13.9195 10.7299 14 10.6181 14 10.5C14 10.3819 13.9195 10.2702 13.781 10.1964L7.94768 7.08522ZM12.4829 10.5L8.16667 12.802V8.19801L12.4829 10.5Z"
              fill="#C4C4C4"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.73352 1.02953C2.89988 0.863163 3.1696 0.863163 3.33596 1.02953L5.59069 3.28425L7.84542 1.02953C8.01178 0.863163 8.28151 0.863163 8.4479 1.02953C8.61421 1.19589 8.61421 1.46561 8.4479 1.63197L6.61913 3.46071H16.6665C17.8428 3.46071 18.7964 4.41432 18.7964 5.59066V15.8145C18.7964 16.9908 17.8428 17.9444 16.6665 17.9444H3.03474C1.8584 17.9444 0.904785 16.9908 0.904785 15.8145V5.59066C0.904785 4.41432 1.8584 3.46071 3.03474 3.46071H4.56225L2.73352 1.63197C2.56716 1.46561 2.56716 1.19589 2.73352 1.02953ZM3.03474 4.31269C2.32893 4.31269 1.75677 4.88486 1.75677 5.59066V15.8145C1.75677 16.5202 2.32893 17.0924 3.03474 17.0924H16.6665C17.3723 17.0924 17.9444 16.5202 17.9444 15.8145V5.59066C17.9444 4.88486 17.3723 4.31269 16.6665 4.31269H3.03474Z"
              fill="#C4C4C4"
            />
          </svg>
          <svg
            v-else
            width="26"
            height="24"
            viewBox="0 0 19 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="b-icon"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M7.5 11.8155V9.18454C7.5 8.42548 8.31248 7.94317 8.97885 8.30665L13 10.5L8.97885 12.6934C8.31248 13.0568 7.5 12.5745 7.5 11.8155Z"
                fill="#5B5B5B"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M7.94768 7.08522C7.77268 6.99184 7.53275 6.97363 7.33065 7.03839C7.12853 7.10314 7 7.2394 7 7.38889V13.6111C7 13.7606 7.12853 13.8969 7.33065 13.9616C7.53275 14.0264 7.77268 14.0082 7.94768 13.9147L13.781 10.8036C13.9195 10.7299 14 10.6181 14 10.5C14 10.3819 13.9195 10.2702 13.781 10.1964L7.94768 7.08522ZM12.4829 10.5L8.16667 12.802V8.19801L12.4829 10.5Z"
                fill="#5B5B5B"
              />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M2.73352 1.02953C2.89988 0.863163 3.1696 0.863163 3.33596 1.02953L5.59069 3.28425L7.84542 1.02953C8.01178 0.863163 8.28151 0.863163 8.4479 1.02953C8.61421 1.19589 8.61421 1.46561 8.4479 1.63197L6.61913 3.46071H16.6665C17.8428 3.46071 18.7964 4.41432 18.7964 5.59066V15.8145C18.7964 16.9908 17.8428 17.9444 16.6665 17.9444H3.03474C1.8584 17.9444 0.904785 16.9908 0.904785 15.8145V5.59066C0.904785 4.41432 1.8584 3.46071 3.03474 3.46071H4.56225L2.73352 1.63197C2.56716 1.46561 2.56716 1.19589 2.73352 1.02953ZM3.03474 4.31269C2.32893 4.31269 1.75677 4.88486 1.75677 5.59066V15.8145C1.75677 16.5202 2.32893 17.0924 3.03474 17.0924H16.6665C17.3723 17.0924 17.9444 16.5202 17.9444 15.8145V5.59066C17.9444 4.88486 17.3723 4.31269 16.6665 4.31269H3.03474Z"
                fill="#5B5B5B"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="19" height="19" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <svg
            v-if="listing"
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="ml-4 mt-1 b-icon"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M19.251 3.43631H5.50586C4.74674 3.43631 4.13135 4.05171 4.13135 4.81083C4.13135 5.56995 4.74674 6.18535 5.50586 6.18535H19.251C20.0102 6.18535 20.6255 5.56995 20.6255 4.81083C20.6255 4.05171 20.0102 3.43631 19.251 3.43631Z"
                fill="#5B5B5B"
              />
              <path
                d="M2.75673 4.81081C2.75519 4.44686 2.60936 4.09838 2.35125 3.84177C1.81515 3.30885 0.949286 3.30885 0.413182 3.84177C0.15503 4.09838 0.00920282 4.44686 0.00769944 4.81081C-0.00256648 4.89985 -0.00256648 4.9898 0.00769944 5.07884C0.0232487 5.1684 0.0485913 5.25598 0.0832979 5.34C0.120195 5.42139 0.163879 5.49957 0.213877 5.57366C0.263231 5.65072 0.320832 5.72216 0.385691 5.78672C0.448232 5.849 0.517344 5.90432 0.591869 5.95166C0.664246 6.00436 0.742722 6.04822 0.825537 6.08224C0.916641 6.12949 1.01376 6.16419 1.11419 6.18533C1.20323 6.19529 1.29317 6.19529 1.38222 6.18533C1.74517 6.18563 2.09353 6.04233 2.35125 5.78672C2.41611 5.72216 2.47371 5.65072 2.52306 5.57366C2.57306 5.49957 2.61675 5.42139 2.65364 5.34C2.6975 5.25701 2.73208 5.16943 2.75673 5.07884C2.767 4.9898 2.767 4.89985 2.75673 4.81081Z"
                fill="#5B5B5B"
              />
              <path
                d="M2.75672 10.9961C2.76695 10.9071 2.76695 10.8172 2.75672 10.7281C2.73297 10.6394 2.69835 10.554 2.65364 10.4738C2.61824 10.3895 2.57447 10.3089 2.52306 10.2333C2.47542 10.1571 2.41761 10.0877 2.35124 10.0271C1.81514 9.49418 0.949278 9.49418 0.413173 10.0271C0.155021 10.2837 0.00919381 10.6322 0.00769043 10.9961C0.0103536 11.1773 0.0452749 11.3564 0.110779 11.5253C0.145228 11.6066 0.186635 11.6848 0.234486 11.759C0.28676 11.8337 0.346638 11.9028 0.413173 11.9652C0.473909 12.0314 0.543237 12.0892 0.61935 12.137C0.691727 12.1897 0.770161 12.2336 0.853018 12.2676C0.936821 12.3028 1.02449 12.3282 1.11418 12.3432C1.2021 12.3629 1.29209 12.3721 1.38221 12.3707C1.47125 12.3809 1.5612 12.3809 1.65024 12.3707C1.73769 12.3557 1.82308 12.3303 1.90452 12.2951C1.98962 12.2613 2.07037 12.2174 2.14506 12.1645C2.22118 12.1167 2.29051 12.0589 2.35124 11.9927C2.41748 11.9319 2.47529 11.8626 2.52306 11.7865C2.57589 11.7142 2.61975 11.6357 2.65364 11.5528C2.70058 11.4616 2.73525 11.3645 2.75672 11.2642C2.76729 11.1751 2.76729 11.0852 2.75672 10.9961Z"
                fill="#5B5B5B"
              />
              <path
                d="M2.75669 17.1815C2.76687 17.0924 2.76687 17.0025 2.75669 16.9134C2.73293 16.8226 2.69831 16.7349 2.6536 16.6523C2.6167 16.5709 2.57302 16.4927 2.52302 16.4186C2.47525 16.3425 2.41744 16.2732 2.3512 16.2124C1.8151 15.6795 0.949239 15.6795 0.413135 16.2124C0.3469 16.2732 0.289085 16.3425 0.24132 16.4186C0.191322 16.4927 0.147639 16.5709 0.110741 16.6523C0.0750898 16.736 0.0497042 16.8237 0.0351429 16.9134C0.0157709 17.0015 0.00657878 17.0914 0.00765262 17.1815C0.00919895 17.5454 0.155027 17.8939 0.413135 18.1505C0.473871 18.2167 0.543199 18.2746 0.619312 18.3223C0.691689 18.3751 0.770123 18.4189 0.85298 18.4529C0.936783 18.4882 1.02445 18.5135 1.11414 18.5285C1.20206 18.5482 1.29205 18.5574 1.38217 18.556C1.47121 18.5663 1.56116 18.5663 1.6502 18.556C1.73765 18.541 1.82305 18.5156 1.90449 18.4804C1.98958 18.4466 2.07033 18.4028 2.14503 18.3498C2.22114 18.302 2.29047 18.2442 2.3512 18.178C2.41744 18.1173 2.47525 18.0479 2.52302 17.9718C2.57589 17.8995 2.61975 17.8211 2.6536 17.7381C2.7005 17.6469 2.73517 17.5498 2.75669 17.4495C2.76725 17.3605 2.76725 17.2705 2.75669 17.1815Z"
                fill="#5B5B5B"
              />
              <path
                d="M20.6255 9.62164H5.50586C4.74674 9.62164 4.13135 10.237 4.13135 10.9962C4.13135 11.7553 4.74674 12.3707 5.50586 12.3707H20.6255C21.3847 12.3707 22.0001 11.7553 22.0001 10.9962C22.0001 10.237 21.3847 9.62164 20.6255 9.62164Z"
                fill="#5B5B5B"
              />
              <path
                d="M14.4402 15.8069H5.50586C4.74674 15.8069 4.13135 16.4223 4.13135 17.1815C4.13135 17.9406 4.74674 18.556 5.50586 18.556H14.4402C15.1993 18.556 15.8147 17.9406 15.8147 17.1815C15.8147 16.4223 15.1993 15.8069 14.4402 15.8069Z"
                fill="#5B5B5B"
              />
              <path
                d="M17 18.382V15.618C17 14.8747 17.7823 14.3912 18.4472 14.7236L21.2111 16.1056C21.9482 16.4741 21.9482 17.5259 21.2111 17.8944L18.4472 19.2764C17.7823 19.6088 17 19.1253 17 18.382Z"
                fill="#5B5B5B"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="23" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            v-else
            width="23"
            height="22"
            viewBox="0 0 23 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="ml-4 mt-1 b-icon"
            @click="selectlisting()"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M19.251 3.43631H5.50586C4.74674 3.43631 4.13135 4.05171 4.13135 4.81083C4.13135 5.56995 4.74674 6.18535 5.50586 6.18535H19.251C20.0102 6.18535 20.6255 5.56995 20.6255 4.81083C20.6255 4.05171 20.0102 3.43631 19.251 3.43631Z"
                fill="#C4C4C4"
              />
              <path
                d="M2.75673 4.81081C2.75519 4.44686 2.60936 4.09838 2.35125 3.84177C1.81515 3.30885 0.949286 3.30885 0.413182 3.84177C0.15503 4.09838 0.00920282 4.44686 0.00769944 4.81081C-0.00256648 4.89985 -0.00256648 4.9898 0.00769944 5.07884C0.0232487 5.1684 0.0485913 5.25598 0.0832979 5.34C0.120195 5.42139 0.163879 5.49957 0.213877 5.57366C0.263231 5.65072 0.320832 5.72216 0.385691 5.78672C0.448232 5.849 0.517344 5.90432 0.591869 5.95166C0.664246 6.00436 0.742722 6.04822 0.825537 6.08224C0.916641 6.12949 1.01376 6.16419 1.11419 6.18533C1.20323 6.19529 1.29317 6.19529 1.38222 6.18533C1.74517 6.18563 2.09353 6.04233 2.35125 5.78672C2.41611 5.72216 2.47371 5.65072 2.52306 5.57366C2.57306 5.49957 2.61675 5.42139 2.65364 5.34C2.6975 5.25701 2.73208 5.16943 2.75673 5.07884C2.767 4.9898 2.767 4.89985 2.75673 4.81081Z"
                fill="#C4C4C4"
              />
              <path
                d="M2.75679 10.9961C2.76701 10.9071 2.76701 10.8172 2.75679 10.7281C2.73303 10.6394 2.69841 10.554 2.6537 10.4738C2.6183 10.3895 2.57453 10.3089 2.52312 10.2333C2.47548 10.1571 2.41767 10.0877 2.3513 10.0271C1.8152 9.49418 0.949339 9.49418 0.413234 10.0271C0.155082 10.2837 0.00925484 10.6322 0.00775146 10.9961C0.0104146 11.1773 0.0453359 11.3564 0.11084 11.5253C0.145289 11.6066 0.186696 11.6848 0.234547 11.759C0.286821 11.8337 0.346699 11.9028 0.413234 11.9652C0.47397 12.0314 0.543298 12.0892 0.619412 12.137C0.691788 12.1897 0.770222 12.2336 0.853079 12.2676C0.936882 12.3028 1.02455 12.3282 1.11424 12.3432C1.20216 12.3629 1.29215 12.3721 1.38227 12.3707C1.47131 12.3809 1.56126 12.3809 1.6503 12.3707C1.73775 12.3557 1.82314 12.3303 1.90459 12.2951C1.98968 12.2613 2.07043 12.2174 2.14513 12.1645C2.22124 12.1167 2.29057 12.0589 2.3513 11.9927C2.41754 11.9319 2.47535 11.8626 2.52312 11.7865C2.57595 11.7142 2.61981 11.6357 2.6537 11.5528C2.70065 11.4616 2.73531 11.3645 2.75679 11.2642C2.76735 11.1751 2.76735 11.0852 2.75679 10.9961Z"
                fill="#C4C4C4"
              />
              <path
                d="M2.75675 17.1815C2.76693 17.0924 2.76693 17.0025 2.75675 16.9134C2.73299 16.8226 2.69837 16.7349 2.65366 16.6523C2.61676 16.5709 2.57308 16.4927 2.52308 16.4186C2.47531 16.3425 2.4175 16.2732 2.35126 16.2124C1.81516 15.6795 0.9493 15.6795 0.413196 16.2124C0.346961 16.2732 0.289146 16.3425 0.241381 16.4186C0.191383 16.4927 0.1477 16.5709 0.110802 16.6523C0.0751509 16.736 0.0497653 16.8237 0.035204 16.9134C0.0158319 17.0015 0.00663981 17.0914 0.00771365 17.1815C0.00925998 17.5454 0.155088 17.8939 0.413196 18.1505C0.473932 18.2167 0.54326 18.2746 0.619374 18.3223C0.69175 18.3751 0.770184 18.4189 0.853041 18.4529C0.936844 18.4882 1.02451 18.5135 1.1142 18.5285C1.20213 18.5482 1.29211 18.5574 1.38223 18.556C1.47127 18.5663 1.56122 18.5663 1.65026 18.556C1.73771 18.541 1.82311 18.5156 1.90455 18.4804C1.98964 18.4466 2.07039 18.4028 2.14509 18.3498C2.2212 18.302 2.29053 18.2442 2.35126 18.178C2.4175 18.1173 2.47531 18.0479 2.52308 17.9718C2.57595 17.8995 2.61981 17.8211 2.65366 17.7381C2.70056 17.6469 2.73523 17.5498 2.75675 17.4495C2.76731 17.3605 2.76731 17.2705 2.75675 17.1815Z"
                fill="#C4C4C4"
              />
              <path
                d="M20.6255 9.62164H5.50586C4.74674 9.62164 4.13135 10.237 4.13135 10.9962C4.13135 11.7553 4.74674 12.3707 5.50586 12.3707H20.6255C21.3847 12.3707 22.0001 11.7553 22.0001 10.9962C22.0001 10.237 21.3847 9.62164 20.6255 9.62164Z"
                fill="#C4C4C4"
              />
              <path
                d="M14.4402 15.8069H5.50586C4.74674 15.8069 4.13135 16.4223 4.13135 17.1815C4.13135 17.9406 4.74674 18.556 5.50586 18.556H14.4402C15.1993 18.556 15.8147 17.9406 15.8147 17.1815C15.8147 16.4223 15.1993 15.8069 14.4402 15.8069Z"
                fill="#C4C4C4"
              />
              <path
                d="M17 18.382V15.618C17 14.8747 17.7823 14.3912 18.4472 14.7236L21.2111 16.1056C21.9482 16.4741 21.9482 17.5259 21.2111 17.8944L18.4472 19.2764C17.7823 19.6088 17 19.1253 17 18.382Z"
                fill="#C4C4C4"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="23" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <svg
            v-if="!chart"
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="ml-4 mt-1 b-icon"
            @click="selectChart()"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M14.2387 16.6307C14.0959 16.4469 13.8378 16.3996 13.639 16.5208C10.838 18.2355 7.17734 17.355 5.46262 14.554C3.74789 11.753 4.62845 8.09237 7.42942 6.37765C8.1201 5.95482 8.88983 5.67754 9.69146 5.56276C9.91693 5.5304 10.0843 5.33724 10.0843 5.1095V1.37354C10.0843 1.12068 9.87929 0.91568 9.62643 0.91568C4.3246 0.91568 0.0117188 5.63972 0.0117188 11.4461C0.0182859 17.2591 4.72906 21.9699 10.5421 21.9765C12.6527 22.1405 14.7397 21.4421 16.3265 20.0407C16.5179 19.8832 16.5492 19.6019 16.397 19.4061L14.2387 16.6307Z"
                fill="#C4C4C4"
              />
              <path
                d="M11.4579 4.57845C14.7433 4.58248 17.4058 7.2449 17.4098 10.5304C17.4098 10.7833 17.6148 10.9883 17.8677 10.9883H21.5304C21.7833 10.9883 21.9883 10.7833 21.9883 10.5304C21.9817 4.71735 17.2709 0.00656719 11.4579 0C11.205 0 11 0.204999 11 0.457858V4.12059C11 4.37345 11.205 4.57845 11.4579 4.57845Z"
                fill="#C4C4C4"
              />
              <path
                d="M21.5303 11.9039H17.7952C17.5657 11.9016 17.37 12.0695 17.3374 12.2967C17.1311 13.7383 16.4025 15.0538 15.2899 15.9934C15.0976 16.1544 15.0706 16.4402 15.2295 16.6343L17.9656 20.0224C18.0454 20.1214 18.1628 20.1828 18.2897 20.1918H18.3254C18.4413 20.1919 18.5529 20.148 18.6377 20.0691C20.7717 18.0734 21.9845 15.2835 21.9882 12.3618C21.9882 12.1089 21.7832 11.9039 21.5303 11.9039Z"
                fill="#C4C4C4"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="22" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <svg
            v-else
            width="22"
            height="22"
            viewBox="0 0 22 22"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="ml-4 mt-1 b-icon"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M14.2387 16.6307C14.0959 16.4469 13.8378 16.3996 13.639 16.5208C10.838 18.2355 7.17734 17.355 5.46262 14.554C3.74789 11.753 4.62845 8.09237 7.42942 6.37765C8.1201 5.95482 8.88983 5.67754 9.69146 5.56276C9.91693 5.5304 10.0843 5.33724 10.0843 5.1095V1.37354C10.0843 1.12068 9.87929 0.91568 9.62643 0.91568C4.3246 0.91568 0.0117188 5.63972 0.0117188 11.4461C0.0182859 17.2591 4.72906 21.9699 10.5421 21.9765C12.6527 22.1405 14.7397 21.4421 16.3265 20.0407C16.5179 19.8832 16.5492 19.6019 16.397 19.4061L14.2387 16.6307Z"
                fill="#5B5B5B"
              />
              <path
                d="M11.4579 4.57845C14.7433 4.58248 17.4058 7.2449 17.4098 10.5304C17.4098 10.7833 17.6148 10.9883 17.8677 10.9883H21.5304C21.7833 10.9883 21.9883 10.7833 21.9883 10.5304C21.9817 4.71735 17.2709 0.00656719 11.4579 0C11.205 0 11 0.204999 11 0.457858V4.12059C11 4.37345 11.205 4.57845 11.4579 4.57845Z"
                fill="#5B5B5B"
              />
              <path
                d="M21.5303 11.9039H17.7952C17.5657 11.9016 17.37 12.0695 17.3374 12.2967C17.1311 13.7383 16.4025 15.0538 15.2899 15.9934C15.0976 16.1544 15.0706 16.4402 15.2295 16.6343L17.9656 20.0224C18.0454 20.1214 18.1628 20.1828 18.2897 20.1918H18.3254C18.4413 20.1919 18.5529 20.148 18.6377 20.0691C20.7717 18.0734 21.9845 15.2835 21.9882 12.3618C21.9882 12.1089 21.7832 11.9039 21.5303 11.9039Z"
                fill="#5B5B5B"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="22" height="22" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </div>

        <!--- bottom icons start --->
      </div>
    </div>

    <div style="display:flex" v-else-if="focus && focus.state == 'ondeck'">
      <div>
        <div style="display:flex">
          <textarea
            style="flex:1"
            placeholder="put youtube url here..a."
            v-model="inputYtbUrl"
          />
          <button @click="handleAddVideo" style="height: fit-content">
            Add
          </button>
        </div>
        <div v-if="tool.plan && tool.plan.videos && tool.plan.videos.length">
          <div
            style="display:flex; border: 1px solid #e8e8e9"
            v-for="(video, index) in tool.plan.videos.filter(
              el => !el._deleted_at
            )"
            :key="index"
            class="my-3 p-1"
          >
            <span
              v-if="isEditingVideo !== index"
              style="max-width: 75%"
              class="mr-2"
              >{{ video.video_url }}</span
            >
            <img
              v-if="isEditingVideo !== index"
              :title="video.video_url"
              :src="video.img_url"
              :height="150"
              :width="150"
              class="mr-4"
            />
            <input
              v-else
              style="max-width: 75%"
              class="mr-2"
              v-model="editVideoInput"
            />
            <span
              style="flex: 1; display: flex; justify-content: flex-end; align-items: center"
            >
              <button
                v-if="isEditingVideo !== index"
                style="height: fit-content"
                @click="handleEditVideo(index, video)"
              >
                Edit
              </button>
              <button
                v-else
                style="height: fit-content"
                @click="handleConfirmEditVideo(index, video)"
              >
                Save
              </button>
              <button
                style="height: fit-content"
                @click="handleRemoveVideo(index, video)"
              >
                Remove
              </button>
            </span>
          </div>
        </div>
      </div>
    </div>
    <div style="display:flex" v-else-if="this.isTrack">
      <div>
        <div style="display:flex">
          <textarea
            style="flex:1"
            placeholder="put youtube url here..a."
            v-model="inputYtbUrl"
          />
          <button @click="handleAddTrackVideo" style="height: fit-content">
            Add
          </button>
        </div>
        <div v-if="this.videos && this.videos.length">
          <div
            style="display:flex; border: 1px solid #e8e8e9"
            v-for="(video, index) in this.videos.filter(el => !el._deleted_at)"
            :key="index"
            class="my-3 p-1"
          >
            <span
              v-if="isEditingVideo !== index"
              style="max-width: 75%"
              class="mr-2"
              >{{ video.video_url }}</span
            >
            <img
              v-if="isEditingVideo !== index"
              :title="video.video_url"
              :src="video.img_url"
              :height="150"
              :width="150"
              class="mr-4"
            />
            <input
              v-else
              style="max-width: 75%"
              class="mr-2"
              v-model="editVideoInput"
            />
            <span
              style="flex: 1; display: flex; justify-content: flex-end; align-items: center"
            >
              <button
                v-if="isEditingVideo !== index"
                style="height: fit-content"
                @click="handleEditVideo(index, video)"
              >
                Edit
              </button>
              <button
                v-else
                style="height: fit-content"
                @click="handleConfirmEditTrackVideo(index, video)"
              >
                Save
              </button>
              <button
                style="height: fit-content"
                @click="handleRemoveTrackVideo(index, video)"
              >
                Remove
              </button>
            </span>
          </div>
        </div>
        <div>
          <button class="btn btn-secondary btn-sm mt-3" @click="saveVideosToAT">
            Add Videos to Tracks
          </button>
        </div>
      </div>
    </div>

    <div v-if="focus && focus.state == 'stationed'">
      <!-- <div style="display:flex">
          <canvas :id="tool && tool.text"></canvas>
        </div> -->
      <div v-if="tool.plan && tool.plan.videos && tool.plan.videos.length">
        <div
          style="display:flex; border: 1px solid #e8e8e9"
          v-for="(video, index) in tool.plan.videos.filter(
            el => !el._deleted_at
          )"
          :key="index"
          class="my-3 p-1"
        >
          <img
            :title="video.video_url"
            :src="video.img_url"
            :height="150"
            :width="150"
            class="mr-4"
          />
        </div>
      </div>
    </div>

    <div
      v-show="videoEmbedUrl"
      :id="tool && tool.text"
      class="modal-video"
      @focusout="
        e => {
          e.stopPropagation();
          videoEmbedUrl = null;
        }
      "
      tabindex="0"
    >
      <!-- @click="(e) => {
          e.stopPropagation()
          videoEmbedUrl = null
        }" -->
      <!-- :style="videoEmbedUrl ? 'display: block': 'display: none'" -->
      <div style="height: 40%;" @click="() => {}">
        <iframe width="100%" height="100%" :src="videoEmbedUrl"> </iframe>
        <textarea
          rows="6"
          placeholder="Your notes here.."
          v-model="noteVideo"
          class="notepad ml-4"
        />
      </div>
    </div>
  </div>
</template>
<script>
import VueApexCharts from "vue-apexcharts";
import Player from "../../../../src/components/common/player";
import Overlay from "../YoutubeViewer/components/Overlay/index.vue";
export default {
  name: "tool-youtubeviewer",
  components: {
    VueApexCharts,
    Overlay,
    Player
  },
  props: {
    tool: {
      type: Object,
      required: false,
      default: () => {}
    },
    focus: {
      type: Object,
      required: false,
      default: () => {}
    },
    user: {
      type: Object,
      default: () => {}
    },
    setTracker: {
      type: Function,
      default: () => () => {}
    },
    addPlan: {
      type: Function,
      default: () => () => {}
    },
    setPlan: {
      type: Function,
      default: () => () => {}
    },
    removePlan: {
      type: Function,
      default: () => () => {}
    },
    isTrack: {
      type: Boolean,
      default: () => false
    }
  },
  watch: {
    videoEmbedUrl(n, o) {
      if (!n && o) {
        this.handleHideVideoModal();
      } else if (n && !o) {
        this.handleShowVideoModal();
      }
    }
  },
  methods: {
    videoPaused(value) {
      // alert(value);
      let logData = {
        _video: this.videoId,
        _verb: value ? "paused" : "played",
        _at: new Date()
      };
      console.log(logData);
    },
    proceedVideo(value) {
      let logData = {
        _verb: value > 0 ? "forward" : "backward",
        _at: new Date(),
        _video: this.videoId
      };
      this.$store.dispatch("tools/addLogOfTools", {
        log: logData,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      // console.log(logData);
    },
    fullScreen(value) {
      let logData = {
        _video: this.videoId,
        _verb: value ? "fullscreen" : "smallscreen",
        _at: new Date()
      };
      console.log(logData);
    },
    scrollRight(index) {
      console.log(this.tool.plan.videos.length - 1, index);
      if (this.tool.plan.videos.length - 1 > index) {
        this.currentIndex = index + 1;
        this.currentContent();
      }
      const el = document.querySelector(".scroll-horizontal");
      el.scrollLeft += 210;
      if (this.tool.plan.videos.length - 2 == index) {
        this.scrollRightBtn = false;
      }
      // alert(el.clientWidth);
      if (el.scrollWidth - 210 >= Math.floor(el.scrollLeft + el.clientWidth)) {
        // setTimeout(() => {
        // }, 200);
      }
      this.scrollLeftBtn = true;
    },
    scrollLeft(index) {
      if (index == 0) {
        this.scrollLeftBtn = false;
      }
      this.currentIndex = index - 1;
      this.currentContent();
      const el = document.querySelector(".scroll-horizontal");
      el.scrollLeft -= 210;
      this.scrollRightBtn = true;
      if (el.scrollLeft <= 210) {
        this.scrollLeftBtn = false;
      }
    },
    currentContent() {
      this.currentVideo = this.tool.plan.videos[this.currentIndex];
      console.log("this.current", this.currentVideo);
      this.videoId = this.currentVideo.videoId;
      this.currentImg = this.currentVideo.img_url;
      this.currentVid = this.currentVideo.video_url + "?autoplay=1&mute=1";
    },
    showScreen() {
      console.log("video", this.currentIndex);
      this.fullscreen = !this.fullscreen;
    },
    showSmallScreen(url, img, videoId) {
      this.videoId = videoId;
      this.currentImg = img;
      this.currentVid = url + "?modestbranding=1";
      this.smallscreen = !this.smallscreen;
    },
    saveVideosToAT() {
      console.log("videos =>", this.videos);
      if (this.videos && this.videos.length) {
        this.$emit("saveVideosToAT", this.videos);
      } else {
        this.videos.toolName = this.tool.name;
        this.$emit("saveVideosToAT", this.videos);
      }
    },
    selectHome() {
      this.home = true;
      this.listing = false;
      this.chart = false;
    },
    selectlisting() {
      this.home = false;
      this.listing = true;
      this.chart = false;
    },
    selectChart() {
      this.home = false;
      this.listing = false;
      this.chart = true;
    },
    handleShowVideoModal() {
      this.trackVideo = {
        _started_at: new Date(),
        video_url: this.videoEmbedUrl
      };
    },
    handleHideVideoModal() {
      this.trackVideo = {
        ...this.trackVideo,
        _ended_at: new Date(),
        text: this.noteVideo
      };
      this.$store.dispatch("tools/addTrackIntoYtbTool", {
        track: this.trackVideo,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      this.setTracker({
        track: this.trackVideo,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      this.videoEmbedUrl = null;
    },
    getEmbedUrl(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);
      let videoId = match && match[2].length === 11 ? match[2] : null;
      return {
        url: `https://www.youtube.com/embed/${videoId}`,
        img: `https://img.youtube.com/vi/${videoId}/0.jpg`,
        videoId: videoId
      };
    },
    handleAddVideo() {
      let embedURL = this.getEmbedUrl(this.inputYtbUrl).url;
      let embedCaptImg = this.getEmbedUrl(this.inputYtbUrl).img;
      let videoId = this.getEmbedUrl(this.inputYtbUrl).videoId;
      let videoToSave = {
        _created_at: new Date(),
        _created_by: this.user.uid,
        video_url: embedURL,
        img_url: embedCaptImg,
        videoId: videoId
      };
      this.$store.dispatch("tools/addVideoIntoYtbTool", {
        video: videoToSave,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      this.addPlan({
        video: videoToSave,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      this.inputYtbUrl = "";
    },
    handleAddTrackVideo() {
      let embedURL = this.getEmbedUrl(this.inputYtbUrl).url;
      let embedCaptImg = this.getEmbedUrl(this.inputYtbUrl).img;
      let videoToSave = {
        _created_at: new Date(),
        _created_by: this.user.uid,
        video_url: embedURL,
        img_url: embedCaptImg,
        name: this.tool.name
      };
      // this.$store.dispatch("tools/addVideoIntoYtbTool", {
      //   video: videoToSave,
      //   focusId: this.focus.focusId,
      //   tools_id: this.tool.tools_id
      // });
      // this.addPlan({
      //   video: videoToSave,
      //   focusId: this.focus.id,
      //   // tools_id: this.tool.tools_id
      // });
      this.videos.push(videoToSave);
    },
    handleEditVideo(index, video) {
      this.isEditingVideo = index;
      this.editVideoInput = video.video_url;
    },
    handleConfirmEditVideo(index, video) {
      console.log("i am here");
      // this.$store.dispatch('tools/editVideoUrlInYtbTool', {video_url: this.editVideoInput, indexVideo:index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.setPlan({
        video_url: this.editVideoInput,
        indexVideo: index,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
      // .then(() => {
      //   })
      this.isEditingVideo = "";
      this.editVideoInput = "";
    },
    handleConfirmEditTrackVideo(index, video) {
      console.log("i am here");
      // this.$store.dispatch('tools/editVideoUrlInYtbTool', {video_url: this.editVideoInput, indexVideo:index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      // this.setPlan({
      //   video_url: this.editVideoInput,
      //   indexVideo: index,
      //   focusId: this.focus.focusId,
      //   tools_id: this.tool.tools_id
      // });
      // .then(() => {
      //   })
      // let foundIndex = this.videos.findIndex(el => el.video_url == video.video_url);
      this.videos[index].video_url = this.editVideoInput;
      this.isEditingVideo = "";
      this.editVideoInput = "";
    },
    handleRemoveVideo(index, video) {
      // this.$store.dispatch('tools/removeVideoInYtbTool', {indexVideo: index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.removePlan({
        indexVideo: index,
        focusId: this.focus.focusId,
        tools_id: this.tool.tools_id
      });
    },
    handleRemoveTrackVideo(index, video) {
      // this.$store.dispatch('tools/removeVideoInYtbTool', {indexVideo: index, focusId: this.focus.focusId, tools_id: this.tool.tools_id})
      this.videos.splice(index, 1);
    },
    handleLaunch(video) {
      this.video = video;
      this.videoEmbedUrl = video.video_url;
    },
    insertVideos() {
      if (
        this.tool &&
        this.tool.plan &&
        this.tool.plan.videos &&
        this.tool.plan.videos.length
      ) {
        this.videos = this.tool && this.tool.plan && this.tool.plan.videos;
      }
    }
  },
  computed: {},
  data: function() {
    return {
      videoId: "",
      playerReady: true,
      currentImg: "",
      currentVid: "",
      currentVideo: "",
      currentIndex: 0,
      scrollRightBtn: true,
      scrollLeftBtn: false,
      fullscreen: false,
      smallscreen: false,
      result: 0,
      showTracking: false,
      tmp_value: 0,
      reset: false,
      operator: undefined,
      tooltype: "calculator",
      videos: [],
      options: {
        legend: {
          position: "bottom",
          colors: ["#1E00D8", "#F33CD6", "#687BFF"]
          // formatter: function(val, opts) {
          //   return val + " - " + opts.w.globals.series[opts.seriesIndex];
          // }
        },
        // width: 200,
        // height: 300,
        labels: ["Watch Time", "Likes", "Totak"],
        // responsive: [
        //   {
        //     breakpoint: 480,
        //     options: {
        //       chart: {
        //         width: 200
        //       },
        //       legend: {
        //         position: "bottom"
        //       }
        //     }
        //   }
        // ],
        // chart: {
        //   toolbar: {
        //     show: true
        //   },
        width: 991,
        height: 500,
        //   type: "area",
        //   animations: {
        //     enabled: true
        //   },
        //   zoom: {
        //     enabled: false
        //   }
        // },
        // markers: {
        //   size: 5,
        //   hover: {
        //     size: 9
        //   },
        //   colors: ["#1E00D8", "#F33CD6", "#687BFF"],
        // },
        dataLabels: {
          enabled: false
        },
        stroke: {
          colors: ["#1E00D8", "#F33CD6", "#687BFF"],
          lineCap: "round"
        },

        fill: {
          type: "solid",
          colors: ["#1E00D8", "#F33CD6", "#687BFF"]
        }
        // xaxis: {
        //   type: "category",
        //   categories: [
        //     "1",
        //     "2",
        //     "3",
        //     "4",
        //     "5",
        //     "6",
        //     "7",
        //     "8",
        //     "9",
        //     "10",
        //     "11",
        //     "12",
        //     "13",
        //     "14",
        //     "15",
        //     "16",
        //     "17",
        //     "18",
        //     "19",
        //     "20",
        //     "21",
        //     "22",
        //     "23",
        //     "24",
        //     "25",
        //     "26",
        //     "27",
        //     "28"
        //   ],
        //   // lines: {
        //   //   show: true
        //   // },
        //   // labels: {
        //   //   show: true,
        //   //   rotate: 0
        //   // }
        // },

        // grid: {
        //   borderColor: "#ddd",
        //   yaxis: {
        //     lines: {
        //       show: true
        //     }
        //   }
        // },
        // tooltip: {
        //   enabled: false,
        //   x: {
        //     format: "dd/MM/yy HH:mm"
        //   }
        // }
      },
      series: [44, 55, 41],
      //state for add / edit video
      inputYtbUrl: "",
      isEditingVideo: "",
      editVideoInput: "",

      //state for watch
      videoEmbedUrl: null,
      trackVideo: null,
      noteVideo: "",

      //state for layers

      listing: true,
      chart: false,
      home: false
    };
  },
  mounted() {
    this.currentContent();
    console.log("tool", this.tool);
    this.insertVideos();
  }
};
</script>
<style lang="scss" scoped>
.uploaded-images-wrapper {
  transform: translateY(-50%);
  position: relative;
  cursor: pointer;
  height: 142px;
  .images-nav {
    cursor: pointer;
    z-index: 1;
    position: absolute;
    top: 84%;
    transform: translateY(-50%);
    width: 44px;
    height: 44px;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s ease-in-out;
    &.left-nav {
      left: 8px;
    }
    &.right-nav {
      right: 31px;
    }
    &.center-nav {
      left: 78px;
    }
  }
  .uploaded-images {
    transition: scroll 3s ease-in-out;
    padding: 0 16px;
    cursor: pointer;
    display: flex;
    column-gap: 16px;
    overflow: scroll;
    position: relative;
    padding-top: 52px;
    &::-webkit-scrollbar {
      height: 0; /* Remove scrollbar space */
      width: 0;
      background: transparent; /* Optional: just make scrollbar invisible */
    }
    .loader {
      width: 168px;
      height: 100px;
    }
    /* Optional: show position indicator in red */
    &::-webkit-scrollbar-thumb {
    }
    .image {
      display: flex;
      column-gap: 4px;
      padding-block: 12px;
      img {
        height: 132px;
        object-fit: cover;
        width: 190px;
        border-radius: 8px;
        &:hover {
          visibility: visible;
          border-style: solid;
          border-color: var(--theme-color);
        }
      }
    }
  }
}
.btm-icons {
  .b-icon {
    cursor: pointer;
  }
}
.b-icon {
  cursor: pointer;
}
.align-items-center {
  display: flex;
  // background: rgb(248, 248, 248);
  width: 204px;
  border-radius: 2px;
}
.add-btn {
  margin-left: 158px;
  margin-top: -32px;
  margin-bottom: 10px;
  cursor: pointer;
}
.cross {
  position: absolute;
  margin-left: 92%;
  cursor: pointer;
}
.ytp-button {
  display: none;
}
.tool-overlay {
  position: fixed;
  top: 0;
  left: 0;
  height: 0%;
  width: 0%;
  z-index: 2;
  background: white;
  transition: 1s;
  border-radius: 20px;
}
.tool-overlay-active {
  height: 100%;
  width: 100%;
  border-radius: 0px;
}
.tool-overlay-small {
  position: fixed;
  top: 23%;
  left: 32%;
  height: 0px;
  width: 0px;
  z-index: 2;
  background: white;
  transition: 1s;
  border-radius: 20px;
}
.tool-overlay-active-small {
  height: 500px;
  width: 470px;
  border-radius: 0px;
  left: 25;
  top: 25;
  right: 25;
  bottom: 25;
}
.url-input {
  flex: 1 1 0%;
  position: absolute;
  width: 165px;
  height: 20px;
  left: 21px;
  top: 47px;
  background: #eaeaea;
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 100px;
  font-size: smaller;
}
.scroll-verticle {
  display: flex;
  overflow-x: auto;
  // width: 150px;
  height: 174px;
  flex-direction: column;
}
.scroll-horizontal {
  display: flex;
  overflow-x: auto;
  width: 200px;
  max-height: 150%;
  flex-direction: row;
}
.chart {
  height: 200px;
}
.calculator {
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 3rem;

  table {
    color: #fff;
  }

  input {
    display: block;
    width: calc(100% - 40px);
    height: 75px;
    padding: 5px 20px 0;
    margin-bottom: 10px;
    border: none;
    background-color: #222;
    color: #fff;
    font-size: 4rem;
    text-align: right;
  }

  .button {
    margin: 10px;
    width: 80px;
    height: 80px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
    border: #6a7a84;
  }

  .button-col2 {
    width: 160px;
    height: 80px;
    text-align: center;
    font-weight: bold;
    cursor: pointer;
  }

  .grey {
    background-color: #ccc;
    color: #333;

    &:hover {
      background-color: #ddd;
    }
  }

  .dark {
    background-color: #444;
    color: #fff;

    &:hover {
      background-color: #555;
    }
  }

  .orange {
    background-color: #e08d1f;
    color: #fff;

    &:hover {
      background-color: #fda22b;
    }
  }
}
.notepad {
  background-color: #ffff;
  border: none;
  width: 100%;
}
.card-body {
  overflow-y: auto;
}
.modal-video {
  background-color: rgba(0, 0, 0, 0.5);
  width: auto;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
